/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Provider_DescInputs */

const es_privacy_policy_sharing_provider_desc = /** @type {(inputs: Privacy_Policy_Sharing_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AWS, Google Cloud o Azure para alojamiento; proveedores de autenticacion; servicios de correo para notificaciones. Todos bajo acuerdos estrictos de confidencialidad.`)
};

const en_privacy_policy_sharing_provider_desc = /** @type {(inputs: Privacy_Policy_Sharing_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AWS, Google Cloud or Azure for hosting; authentication providers; email services for notifications. All under strict confidentiality agreements.`)
};

/**
* | output |
* | --- |
* | "AWS, Google Cloud or Azure for hosting; authentication providers; email services for notifications. All under strict confidentiality agreements." |
*
* @param {Privacy_Policy_Sharing_Provider_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_provider_desc = /** @type {((inputs?: Privacy_Policy_Sharing_Provider_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Provider_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_provider_desc(inputs)
	return en_privacy_policy_sharing_provider_desc(inputs)
});
export { privacy_policy_sharing_provider_desc as "privacy_policy.sharing.provider_desc" }